import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IButtonGroupTextProps from "./type";
import stylesheet, {
    getButtonGroupTextColors,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useAttachedGroupItem
} from "../../../attachedGroup/context";
import {
    getControlMeasures
} from "../../../../helpers/theme/control";
import Text from "../../../text";

const ButtonGroupText: FC<IButtonGroupTextProps> = ({
    icon: IconComponentProp,
    customTheme,
    style,
    title,
    ...props
}) => {
    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const groupItem = useAttachedGroupItem();

    const isDisabled = !!groupItem?.isDisabled;

    const currentSize = getControlMeasures({
        size: groupItem?.size ?? "medium",
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes
    });

    const currentColors = getButtonGroupTextColors({
        variant: groupItem?.groupVariant ?? "outline",
        type: groupItem?.type ?? "neutral",
        isDisabled,
        colors
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        controlPaddings,
        currentColors,
        shapeConfigs,
        currentSize,
        isDisabled,
        groupItem,
        borders,
        spaces
    });

    const renderIcon = () => {
        if(!IconComponentProp) {
            return null;
        }

        return <IconComponentProp
            customColor={currentColors.iconColor}
            size={currentSize.iconSize}
            color="mid"
        />;
    };

    const renderTitle = () => {
        if(!title) {
            return null;
        }

        return <Text
            customColor={currentColors.titleColor}
            variant={currentSize.labelVariant}
            customTheme={customTheme}
            style={stylesheet.title}
            numberOfLines={1}
        >
            {title}
        </Text>;
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {renderIcon()}
        {renderTitle()}
    </View>;
};
export default ButtonGroupText;
